import { Logger } from '@obo-main/utils/logger/logger.service';
import { LoggerLevel } from '@obo-main/utils/logger/loggerLevel.enum';

export function LoggerFactory(logger: Logger, loggerLevel: LoggerLevel): Promise<boolean> {
    logger.setLoggerLevel(loggerLevel);
    return Promise.resolve(true);
}
